export const getInitialState = () => ({
  contents: [],
  error: null,
  isLoading: true,
  isLoadingInfinite: false,
  nextPagePath: null,
  rel: undefined,
});
